var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissedEq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.161,
    height: 51.806,
    viewBox: "0 0 52.161 51.806",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "High_Temp_Icon",
    "data-name": "High Temp Icon",
    transform: "translate(4.903 5.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2839",
    "data-name": "Group 2839",
    transform: "translate(-9 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3142",
    "data-name": "Path 3142",
    d: "M25.806,51.613A25.806,25.806,0,1,1,51.613,25.806,25.836,25.836,0,0,1,25.806,51.613m0-49.987A24.181,24.181,0,1,0,49.987,25.806,24.208,24.208,0,0,0,25.806,1.625",
    transform: "translate(4.645 6.194)",
    fill: "#164295"
  }), /*#__PURE__*/React.createElement("g", {
    id: "High_Temp_Icon-2",
    "data-name": "High Temp Icon",
    transform: "translate(4.097 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2839-2",
    "data-name": "Group 2839",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3142-2",
    "data-name": "Path 3142",
    d: "M25.9,51.806a25.9,25.9,0,1,1,25.9-25.9,25.932,25.932,0,0,1-25.9,25.9m0-50.175A24.271,24.271,0,1,0,50.175,25.9,24.3,24.3,0,0,0,25.9,1.632",
    fill: "#164295"
  }), /*#__PURE__*/React.createElement("text", {
    id: "EQ",
    transform: "translate(25.903 33.999)",
    fill: "#004f9f",
    fontSize: 23,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16,
    y: 0
  }, "EQ"))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissedEq);
export default __webpack_public_path__ + "static/media/Missed_EQ.cb2544e52429244c84f7519cb05bb2c3.svg";
export { ForwardRef as ReactComponent };